import { useOneSalebill } from "http-hooks/salebill/useSalebill";
import { useOneVoucher } from "http-hooks/voucher/useVoucher";
import { toIndianCurrencyFormat } from "utils/amount";
import Modal from "components/ui/modals";

export default function DocumentDetailModal({ isOpen, onClose, docType, docId }) {
  const isSalebill = ["SB", "PB", "VDN", "VCN"].includes(docType);
  const { data: salebillData, isLoading: isLoadingSalebill } = useOneSalebill(
    isSalebill ? docId : null,
    { enabled: isSalebill && isOpen }
  );

  const { data: voucherData, isLoading: isLoadingVoucher } = useOneVoucher(
    !isSalebill && docId,
    !isSalebill && isOpen
  );

  const isLoading = isLoadingSalebill || isLoadingVoucher;

  const renderSalebillDetails = () => {
    if (!salebillData) return null;

    const discounts = salebillData.discounts_array || [];

    return (
      <div className="space-y-3">
        <DetailRow label="Doc No" value={salebillData.salebillno} />
        <DetailRow label="Total Quantity in PCs" value={salebillData.totalqtypcs} />

        {discounts.map((discount, index) => (
          discount.amount !== 0 && (
            <DetailRow
              key={discount.order || index}
              label={discount.name || `Discount-${discount.order || index + 1}`}
              value={toIndianCurrencyFormat(discount.amount, true)}
            />
          )
        ))}

        {salebillData.igstamt > 0 ? (
          <DetailRow
            label="IGST Amount"
            value={toIndianCurrencyFormat(salebillData.igstamt, true)}
          />
        ) : (
          <>
            <DetailRow
              label="CGST Amount"
              value={toIndianCurrencyFormat(salebillData.cgstamt, true)}
            />
            <DetailRow
              label="SGST Amount"
              value={toIndianCurrencyFormat(salebillData.sgstamt, true)}
            />
          </>
        )}

        <DetailRow
          label="Round Off"
          value={toIndianCurrencyFormat(salebillData.roff, true)}
        />
        <DetailRow
          label="Sale Bill Value"
          value={toIndianCurrencyFormat(salebillData.salebillvalue, true)}
          isHighlight={true}
        />
      </div>
    );
  };

  const renderVoucherDetails = () => {
    if (!voucherData) return null;

    return (
      <div className="space-y-3">
        <DetailRow label="Doc No" value={voucherData.docno} />
        <DetailRow label="Narration" value={voucherData.naration || "-"} />
        <DetailRow label="Document Mode" value={voucherData.docmode || "-"} />
        <DetailRow label="Bank" value={voucherData.bankname || "-"} />
        <DetailRow label="Transaction No." value={voucherData.trnid || "-"} />
        <DetailRow
          label="Transaction Amount"
          value={toIndianCurrencyFormat(voucherData.tramount, true)}
          isHighlight={true}
        />
      </div>
    );
  };

  return (
    <Modal
      open={isOpen}
      setOpen={onClose}
      header={<h3 className="text-lg font-semibold leading-6 text-gray-900">Document Details</h3>}
    >
      {isLoading ? (
        <div className="text-center py-8">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-indigo-600 border-r-transparent"></div>
          <p className="mt-2 text-sm text-gray-600">Loading document details...</p>
        </div>
      ) : (
        isSalebill ? renderSalebillDetails() : renderVoucherDetails()
      )}
    </Modal>
  );
}

function DetailRow({ label, value, isHighlight = false }) {
  return (
    <div className={`flex justify-between py-2 ${isHighlight ? 'border-t-2 border-gray-900 pt-3 font-semibold' : 'border-b border-gray-200'}`}>
      <span className="text-sm text-gray-600">{label}:</span>
      <span className={`text-sm ${isHighlight ? 'text-gray-900 text-base' : 'text-gray-900'}`}>
        {value}
      </span>
    </div>
  );
}
